import React from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";

import { alignCenter } from "@safecv/shared/sharedFunction";

import ViewDetailComponent from "./HeaderComponent/ViewDetailComponent";
import DownloadMenuComponent from "./HeaderComponent/DownloadMenuComponent";
import Step from "./HeaderComponent/Step";

import "./ProcessingScreen.css";

const customModalStyles = {
  content: {
    overflow: "hidden",
    borderRadius: "0px",
    padding: "0px",
    border: "none",
    background: "none",
    textAlign: "center",
    inset: "2% 0",
  },
  overlay: {
    backgroundColor: "rgb(0, 0, 0, 0.9)",
  },
};

const ProcessingScreen = (props) => {
  const {
    planDetails,
    planDetails: { planName, status },
    jobId,
    queryparams,
  } = props;
  return (
    <Modal isOpen={true} style={customModalStyles} ariaHideApp={false}>
      <div className="processing-header">
        <div className="processing-header-left">
          <Link to={{ pathname: "/plans", search: `${queryparams}` }}>
            <div className="arrow left" />
          </Link>
          <div className="header-plan-name" title={planName}>
            {planName}
          </div>
          <ViewDetailComponent planDetails={planDetails} headerHeight={40} />
          <Step status={status.toLowerCase()} />
        </div>
        <div className="processing-header-right">
          <DownloadMenuComponent jobId={jobId} headerHeight={40} />
        </div>
      </div>
      <FadeLoader
        css={alignCenter}
        height={15}
        width={5}
        radius={1}
        margin={2}
        color={"#ffffff"}
        loading={true}
      />
      <div className="message-container-first">
        <div> Processing is in progress. </div>
        <div>
          It can take upto 15mins. Once the processing is over, you can
        </div>
        <div>
          {status.includes("verification") ? " download " : " view "} the
          documents
        </div>
      </div>
      <div className="message-container-second"> Meantime you can explore </div>
      <Link
        to={{
          pathname: "/plans",
        }}
        className="message-link"
      >
        other plan reviews
      </Link>
    </Modal>
  );
};

export default ProcessingScreen;
